import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.143 4.4a.3.3 0 0 0-.3.3v14.6a.3.3 0 0 0 .3.3h11.713a.3.3 0 0 0 .3-.3V9.009h-2.908a1.7 1.7 0 0 1-1.7-1.7V4.4H6.143Zm8.805.99 2.218 2.219h-1.918a.3.3 0 0 1-.3-.3v-1.92ZM4.443 4.7a1.7 1.7 0 0 1 1.7-1.7h8.105a.7.7 0 0 1 .495.205l4.608 4.609a.7.7 0 0 1 .205.495V19.3a1.7 1.7 0 0 1-1.7 1.7H6.143a1.7 1.7 0 0 1-1.7-1.7V4.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.7 11.297v3.785h.001l.002.001h.002l3.194-1.89.002-.001v-.005H13.9l-3.196-1.89-.002-.002-.002.002Zm.717-1.205A1.403 1.403 0 0 0 9.3 11.3v3.78a1.403 1.403 0 0 0 2.117 1.208l3.195-1.89a1.404 1.404 0 0 0 0-2.416l-3.195-1.89Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=VideoFileIcon24.js.map